<div class="eye-view-consignee mb-2">
    <div class="row eye-view-consignee-row">
        <div class="col-4 mogo-bold text-end eye-view-consignee-header">
            Delivery Point
        </div>
        <div class="col-8 eye-view-consignee-content">
            {{ currentLegData?.deliveryPointName}}
        </div>
    </div>
    <div class="row eye-view-consignee-row">
        <div class="col-4 mogo-bold text-end eye-view-consignee-header">
            Delivery Address
        </div>
        <div class="col-8 eye-view-consignee-content">
            {{ currentLegData?.deliveryPointAddress}}
        </div>
    </div>
    <div class="row ">
        <div class="col-4 mogo-bold text-end eye-view-consignee-header">
            Site Contact
        </div>
        <div class="col-8 eye-view-consignee-content">
            Name: {{ toJobContact?.name || '' }}<br>
            Phone: {{ toJobContact?.phone || '' }}<br>
            Email: {{ toJobContact?.email || '' }}
        </div>
    </div>
</div>